
(function () {
  'use strict';

  if (customElements.get('pi-coupon-box')) return;

  class PiCouponBox extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.handleClick = this.handleClick.bind(this);

      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      clearTimeout(this.resetTimer);
      this.initialized = false;
    }

    async handleClick(event) {
      var button = event.target.closest('[data-pi-copy-coupon]');

      if (!button || !this.contains(button)) return;

      var code = button.getAttribute('data-coupon-code') || '';
      var label = button.querySelector('[data-pi-copy-label]');
      var status = this.querySelector('[data-pi-coupon-status]');

      var copyText = button.getAttribute('data-copy-text') || 'COPY';
      var copiedText = button.getAttribute('data-copied-text') || 'COPIED ✓';

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          var textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';

          document.body.appendChild(textarea);
          textarea.select();

          var copied = document.execCommand('copy');
          textarea.remove();

          if (!copied) throw new Error('Copy failed');
        }

        button.classList.add('copied');

        if (label) label.textContent = copiedText;
        if (status) status.textContent = 'Coupon code copied: ' + code;

        clearTimeout(this.resetTimer);

        this.resetTimer = setTimeout(function () {
          button.classList.remove('copied');
          if (label) label.textContent = copyText;
        }, 2000);
      } catch (error) {
        if (status) status.textContent = 'Unable to copy automatically. Coupon code: ' + code;
        window.prompt('Copy your coupon code:', code);
      }
    }
  }

  customElements.define('pi-coupon-box', PiCouponBox);

  function initCouponBoxes() {
    document.querySelectorAll('[data-pi-coupon-box]').forEach(function (box) {
      if (box.closest('pi-coupon-box')) return;

      var wrapper = document.createElement('pi-coupon-box');
      box.parentNode.insertBefore(wrapper, box);
      wrapper.appendChild(box);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCouponBoxes);
  } else {
    initCouponBoxes();
  }

  document.addEventListener('shopify:section:load', initCouponBoxes);
})();
